// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { CheckboxPresentationProps, StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox";
import getColor from "@insite/mobius/utilities/getColor";
import checkboxThemeStyle from "@rugby/XDL/PreStyle/checkbox";
import { ellipsis } from "@rugby/XDL/Utilities";
import { styledScrollbar } from "@rugby/XDL/Utilities/SharedStyles";
import React from "react";
import { css } from "styled-components";

const checkboxStyle: CheckboxPresentationProps = {
    css: css<CheckboxStyleProps>`
        ${checkboxThemeStyle.defaultProps?.css}
        align-items: center;
        span[role="checkbox"] {
            height: 22px;
            width: 22px;
            min-width: 22px;
            background: ${getColor("common.white")};
        }
    `,
    typographyProps: {
        size: 15,
        css: css`
            letter-spacing: 0;
            line-height: 18px;
            ${wrapInContainerStyles}
            ${ellipsis(2, 18)}
            color: ${getColor("secondary.main")};
        `,
    },
};

const customProductListFiltersAccordionSectionStyle = {
    accordionSection: {
        headerProps: {
            css: css`
                button {
                    min-height: 42px;
                    background: ${getColor("common.ui3")};
                }
            `,
        },
        panelProps: {
            css: css`
                overflow-y: auto;
                overflow-x: hidden;
                max-height: 350px;
            `,
        },
    },
    checkBox: {
        css: css`
            ${checkboxStyle.css}

            &,
            label {
                width: 100%;
            }
        `,
        typographyProps: checkboxStyle.typographyProps,
    },
    checkBoxSelected: {
        css: css`
            ${checkboxStyle.css}

            &,
            label {
                width: 100%;
            }
        `,
        typographyProps: {
            ...checkboxStyle.typographyProps,
            css: css`
                ${checkboxStyle.typographyProps?.css}
                font-weight: normal;
            `,
        },
    },
    checkBoxGroup: {
        css: css`
            width: 100%;
            padding-right: 15px;
            &:not(:last-child) {
                padding-bottom: 15px;
            }
        `,
    },
    attributeLabel: checkboxStyle.typographyProps,
    attributeCountLabel: {
        ...checkboxStyle.typographyProps,
        size: 13,
        color: "secondary",
        css: css`
            ${checkboxStyle.typographyProps?.css}
            font-weight: bold;

            display: flex;
            min-width: 54px;
            justify-content: flex-end;
            text-align: right;
        `,
    },
    // custom proprieties
    // if you add any custom propriety, we need to add the name to customProprietyInProductListFiltersAccordionSectionStyle variable
    checkboxListStyle: {
        wrapper: {
            css: css`
                padding-top: 24px;
                border-top: 1px solid ${getColor("common.border")};
                overflow: hidden;
                padding-left: 5px;
                padding-bottom: 5px;
            `,
        },
        title: {
            size: 18,
            variant: "p",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
                margin-bottom: 24px;
            `,
        },
    },
    container: {
        css: css`
            max-height: 300px;
            overflow-y: auto;
            overflow-x: hidden;
            ${styledScrollbar()}
        `,
    },
};

// custom proprieties list
const customProprietiesInProductListFiltersAccordionSectionStyle: any[] = ["checkboxListStyle"];

export default customProductListFiltersAccordionSectionStyle;
export { customProprietiesInProductListFiltersAccordionSectionStyle };
